export default "__VITE_ASSET__5kEMuUPr__"